import { EDPContact, EDPRepresentativeInfo } from '../edp/company-contact';
import { CompanyClass, CompanyOptions } from './company.class';

export class RepresentativeClass extends CompanyClass {
  contacts: EDPContact[];

  static fromEDPRepresentativeInfoArray(
    edpRepresentativesInfo: EDPRepresentativeInfo[],
    options?: Partial<CompanyOptions>
  ) {
    return (edpRepresentativesInfo || []).map<RepresentativeClass>(
      edpRepresentativeInfo => new RepresentativeClass(edpRepresentativeInfo, options)
    );
  }

  constructor(edpRepresentativeInfo: EDPRepresentativeInfo, options?: Partial<CompanyOptions>) {
    super(edpRepresentativeInfo, options);
    const { contacts } = edpRepresentativeInfo;
    this.contacts = contacts;
  }

  toEDPRepresentativeInfo(): EDPRepresentativeInfo {
    const edpCompanyInfo = super.toEDPCompanyInfo();
    const { contacts } = this;
    return {
      ...edpCompanyInfo,
      contacts,
    };
  }
}
